import { AlertProps } from "@redotech/redo-customer-portal-shared/hooks/useReturnConfirmation/use-return-confirmation";
import AlertCircleIcon from "@redotech/redo-icons/alert-circle.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const AlertsCard = memo(function AlertsCard({
  alerts,
}: {
  alerts: AlertProps[] | undefined;
}) {
  if (!alerts || alerts.length === 0) {
    return null;
  }

  return (
    <Flex dir="column" gap="xl">
      {alerts.map((alert, index) => (
        <Flex
          bgColor="primary-alt"
          borderColor="primary"
          borderRadius="3xl"
          borderStyle="solid"
          borderWidth="1px"
          gap="lg"
          key={index}
          p="xl"
        >
          <Flex>
            <RedoFeaturedIcon
              color="warning"
              Icon={AlertCircleIcon}
              size="sm"
            />
          </Flex>
          <Flex dir="column" gap="lg" grow={1}>
            <Flex dir="column" gap="xs">
              <Text fontSize="sm" fontWeight="semibold" textColor="secondary">
                {alert.title}
              </Text>
              <Text fontSize="sm" textColor="tertiary">
                {alert.subtitle}
              </Text>
            </Flex>
            {(alert.primaryAction || alert.secondaryAction) && (
              <Flex gap="lg">
                {alert.primaryAction && (
                  <RedoButton
                    hierarchy="primary"
                    onClick={alert.primaryAction.onClick}
                    size="sm"
                    text={alert.primaryAction.text}
                  />
                )}
                {alert.secondaryAction && (
                  <RedoButton
                    hierarchy="secondary"
                    onClick={alert.secondaryAction.onClick}
                    size="sm"
                    text={alert.secondaryAction.text}
                  />
                )}
              </Flex>
            )}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
});
